import decoder from '@/decoders/editor'
import useAPI from '../useAPI'
import { create } from '@/api/editor.api'

export const useEditor = (params = {}) => useAPI({
  request: create,
  params,
  decoder
})
